import { Media, WorkspaceRoutine, Addon } from '@gripp/shared-logic';

export interface Product {
  id: string;
  name: string;
  description?: string;
  details?: string;
  specifications?: string;
  coverImage?: Media;
  addons?: Addon[];
  routines?: WorkspaceRoutine[];
  media?: Media[];
}
